import React, { useState } from 'react';
import { Table as AntdTable } from 'antd';
import toast from 'react-hot-toast';
import { getSubDomain } from '../../../../hooks/getSubDomain';
import { IFetchPropsRotas } from '../../types';
import { api } from '../../../../services/api';
import { TableColumnController } from './tableColumnController';

interface ITableComponentProps {
  dataFetch?: IFetchPropsRotas;
  isLoading: boolean;
  refetch: () => void;
  currentPage: number;
  itensPerPage: number;
  setCurrentPage: (event: number) => void;
  setColumnOrdenation: (event: string) => void;
  setItensPerPage: (event: number) => void;
  totalItens: number;
}

export function TableComponent({
  refetch,
  dataFetch,
  totalItens,
  isLoading,
  itensPerPage,
  currentPage,
  setCurrentPage,
  setColumnOrdenation,
  setItensPerPage,
}: ITableComponentProps) {
  const pageSizeOptions = ['10', '20', '30'];

  const [selectDataKeys, setSelectDataKeys] = useState<any>({ keys: [], data: [] });

  function onChange(pagination: any, filters: any, sorter: any) {
    setCurrentPage(pagination.current);
    setItensPerPage(pagination.pageSize);

    if (sorter.order === 'descend') {
      setColumnOrdenation(`${sorter.field}:DESC`);
    } else if (sorter.order === 'ascend') {
      setColumnOrdenation(`${sorter.field}:ASC`);
    } else {
      setColumnOrdenation(``);
    }
  }

  async function handleDeleteFunction(rotaId: string) {
    try {
      await api.delete(getSubDomain() + `rotas/${rotaId}`);
      toast.success('Desativado com sucesso');
    } catch (err) {
      toast.error('Não foi possivel Desativar');
      console.log(err);
    }
    refetch();
  }

  async function handleRestoreFunction(rotaId: string) {
    try {
      await api.put(getSubDomain() + `rotas/restore/${rotaId}`);
      toast.success('Ativado com sucesso');
    } catch (err) {
      toast.error('Não foi possivel Ativar');
      console.log(err);
    }
    refetch();
  }

  const { columns, data } = TableColumnController({
    handleDeleteFunction,
    handleRestoreFunction,
    refetch,
    dataList: dataFetch,
  });

  return (
    <AntdTable
      loading={isLoading}
      showSorterTooltip={false}
      onChange={onChange}
      dataSource={data}
      columns={columns}
      pagination={{
        current: currentPage,
        pageSize: itensPerPage,
        pageSizeOptions,
        total: totalItens,
        showSizeChanger: true,
      }}
    />
  );
}
